<template>
  <div>
    <div :style="`font-size: ${font_size}%;font-family: tahoma;color: black;float: left;width: 100%;padding: 0 25px 0 15px;`">

      <template v-if="table_number">
        <strong style="font-size: 0.7em;text-decoration: underline;">
          {{ $t('apps.pos.message.tablenumber', { ref_name: refName, number: table_number }) }}
        </strong>
        <br>
      </template>

      <ul style="padding: 0;margin: 3mm 0 1mm 0;float: left;width: 100%;">
        <li
          v-for="(order, index) in filterOrder"
          :key="index"
          style="list-style: none;border-bottom: 1px black dotted;margin-bottom: 5px;float: left;width: 100%;"
        >
          <p style="margin: 0;font-size: 0.5em">
            <span>
              {{ order.item }}
            </span>
            <span style="float: right;">
              {{ getNumber(order.price) }}
            </span>
          </p>
          <span
            v-for="(modifier, index_) in order.modifiers"
            :key="index_"
          >
            <p
              v-for="(modifieroption, index__) in modifier.options"
              :key="index__"
              style="margin: 0;font-size: 0.5em"
            >
              + {{ modifieroption.option }}
              <span style="float: right;">
                {{ getNumber(modifieroption.price) }}
              </span>
            </p>
          </span>
          <div
            v-if="order.discount > 0"
            style="float: left;width: 100%;margin-top: 0px;">
            <div style="margin: 0;font-size: 0.5em;">
              {{ $t('message.discount') }}
              <span style="float: right;">
                {{ getNumber(order.discount) }}
              </span>
            </div>
          </div>
          <div style="float: left;width: 100%;margin-top: 0;display: flex;justify-content: space-between;align-items: baseline;">
            <span style="margin: 0;font-size: 0.5em;">
              x{{ order.quantity }} {{ order.unit }}
            </span>
            <span style="float: right;font-size: 0.5em;">
              {{ getNumber(order.total) }}
            </span>
          </div>
        </li>
      </ul>

      <div
        v-if="total_price.discount"
        style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t('message.discounts') }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(total_price.discount) }}</p>
      </div>

      <div
        v-for="(tax, index) in taxes"
        :key="index"
        style="float: left;width: 100%;"
      >
        <span style="font-size: 0.5em;float: left;">
          {{ tax.displayText }}
        </span>
        <p style="margin: 0;font-size: 0.5em;float: right;">
          {{ getNumber(tax.total) }}
        </p>
      </div>

      <div style="float: left;width: 100%;">
        <span style="font-size: 0.5em;float: left;">{{ $t('message.total') }}</span>
        <p style="margin: 0;font-size: 0.5em;float: right;">{{ getNumber(total_price.total) }}</p>
      </div>

      <div
        class="footer"
        style="border-top: dotted 1px #000;padding-top: 10px;margin: 5px 0 0 0;float: left;width: 100%;text-align: center;">
        <p
          class="m-0"
          style="font-size: 0.5em;line-height: 1.5em;">
          {{ dateTime }}
        </p>
        <p
          class="m-0"
          style="font-size: 0.5em;line-height: 1.5em;">
          By TreeSoft.io
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  props: {
    orders: {
      type: Array,
    },
    total_price: {
      type: Object,
    },
    created_at: {
      type: String,
    },
    font_size: {
      type: Number,
      default: () => 100,
    },
  },
  computed: {
    ...mapGetters({
      posSession: 'getPosSession',
      customer_id: 'getPosSelectedCustomerId', // selected customer_id
      table_number: 'getPosSelectedTableNumber', // selected table_number
      posSettings: 'getPosSetting',
    }),
    dateTime () {
      let date = this.created_at
      let x = date.split(' ')
      try {
        return x[1]
      } catch (e) {
        return null
      }
    },
    filterOrder () {
      return this.orders.map((order) => {
        const includeDiscount = true
        const includeTax = false
        const orderTotal = this.getTotal([order], includeDiscount, includeTax)
        return {
          ...order,
          discount: orderTotal.discount,
          total: orderTotal.payment,
        }
      })
    },
    taxes() {
      return this.getTaxesByOrders(this.filterOrder)
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/print/pos/Orders.vue